import styled from "styled-components";
import { pxToRem } from "../../styles/utils";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${({ theme }) => theme.colors.white};
  box-shadow: ${({ theme }) => theme.shadows.md};
  border-radius: ${({ theme }) => pxToRem(theme.radii.lg)};
  background: ${({ theme }) => theme.colors.white};
  padding: ${pxToRem(24)};
  width: ${pxToRem(280)};
`;

export const Title = styled.h3`
  font-size: ${pxToRem(18)};
  font-weight: 600;
  margin-bottom: ${pxToRem(12)};
`;

export const TimeDisplay = styled.div`
  display: flex;
  align-items: center;
  gap: ${pxToRem(16)};
`;

export const TimeBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Text = styled.span`
  color: ${({ theme }) => theme.colors.graySlate};
  font-size: ${pxToRem(18)};
  font-weight: 500;
`;

export const Separator = styled.span`
  color: ${({ theme }) => theme.colors.graySlate};
  font-size: ${pxToRem(48)};
  font-weight: 600;
  margin-bottom: ${pxToRem(30)};
`;

export const TimeInput = styled.div`
  width: ${pxToRem(78)};
  color: ${({ theme }) => theme.colors.black};
  font-size: ${pxToRem(48)};
  font-weight: 700;
  background: transparent;
  border: none;
  outline: none;
  
  &:focus {
    border-bottom: ${pxToRem(2)} solid black;
  }
`;

export const Button = styled.button`
  font-size: ${pxToRem(18)};
  color: ${({ theme }) => theme.colors.grayDeep};
  background: none;
  border: none;
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colors.black};
  }
`;

export const LabelRow = styled.div`
  display: flex;
  justify-content: space-between;
  color: ${({ theme }) => theme.colors.graySubtle};
  font-size: ${pxToRem(14)};
  width: 100%;
  padding: 0 ${pxToRem(20)};
  margin-top: ${pxToRem(8)};
`;
